// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.S0A4IrqC3_95kE {
  display: flex;
  padding: var(--ds-space-200, 16px) var(--ds-space-0, 0);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.S0A4IrqC3_95kE:first-child {
  padding-top: var(--ds-space-0, 0);
}
.sm62Eeay7zMeX_ {
  display: flex;
  flex: 1 1 auto;
}
.W5YJprsbghq07u {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: var(--ds-border-radius-100, 3px);
  background-size: cover;
}
.Dwfq5xn2N6eqYf {
  display: block;
  margin: auto var(--ds-space-100, 8px) auto var(--ds-space-100, 8px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rn_VVuPLKUYJrC {
  display: flex;
  flex: 0 0 auto;
}
.u2pifQKNOYjL9E {
  margin: auto var(--ds-space-0, 0);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardRow": `S0A4IrqC3_95kE`,
	"boardRowLeftContainer": `sm62Eeay7zMeX_`,
	"boardThumbnail": `W5YJprsbghq07u`,
	"boardName": `Dwfq5xn2N6eqYf`,
	"boardRowRightContainer": `rn_VVuPLKUYJrC`,
	"boardDateClosed": `u2pifQKNOYjL9E`
};
export default ___CSS_LOADER_EXPORT___;
